<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('license_report.title')"/>
    <div class="search-form px-2 my-2 pb-2">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <div class="row">
          <div class="col-sm-6">
              <span>{{ $t('license_report.date') }}</span>
              <select v-model="month" class="form-select form-select-sm mb-2">
                  <option v-for="(month, index) in months" :key="index" :value="month.value">{{ month.text }}</option>
              </select>
          </div>
          <div class="col-sm-6">
              <span>{{ $t('license_report.year') }}</span>
              <select v-model="year" class="form-select form-select-sm mb-2">
                  <option v-for="(year, index) in years" :key="index" :value="year.value">{{ year.text }}</option>
              </select>
          </div>
      </div>
      <div v-if="isAdmin" class="col-12 mb-2" style="height: 10em">
        <span>
          {{ $t('users.license_holder_title') }}
        </span>
          <company-selector
              v-if="isAdmin"
              v-model="company"
              :placeholder="$t('users.license_holder_title')"
          />
      </div>
      <div class="col-12 d-flex justify-content-end">
        <button
          class="btn btn-primary form-button"
          @click.stop="fetchUsers"
        >
          {{ $t('common.search_verb') }}
        </button>
      </div>
    </div>

    <div class="col-sm-12 d-flex justify-content-end pt-1 mb-2">
      <font-awesome-icon
        v-if="users.length > 0"
        icon="print"
        class="print-icon"
        @click.stop="print"
      />
    </div>
    <div
      v-if="users.length > 0"
      id="printContainer"
      class="report"
    >
      <h1>{{ $t('license_report.title') }}</h1>
      <div class="hint-text pb-2">
        {{ $t('license_report.parenthesis_description') }}
      </div>
      <table
        class="table table-sm table-fixed"
        style="font-size: .9em"
      >
          <tbody>
              <tr>
              <td class="item-detail-title">
                {{ $t('users.company_super_user') }}
              </td>
              <td class="item-detail-text">
                {{ superusers[0] }}
                <span v-if="superusers[1] > 0">
                  ({{ superusers[1] }})
                </span>
              </td>
            </tr>
            <tr>
              <td class="item-detail-title">
                {{ $t('users.observer') }}
              </td>
              <td class="item-detail-text">
                {{ observers[0] }}
                <span v-if="observers[1] > 0">
                  ({{ observers[1] }})
                </span>
              </td>
            </tr>
            <tr>
              <td class="item-detail-title">
                {{ $t('users.worker') }}
              </td>
              <td class="item-detail-text">
                {{ workers[0] }}
                <span v-if="workers[1] > 0">
                  ({{ workers[1] }})
                </span>
              </td>
            </tr>
          </tbody>
      </table>
      <h2>{{ $t('license_report.title_users') }}</h2>
      <div
        class="col-sm-12 list-content result-table"
      >
        <license-report-table :users="users"/>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin';
import {Roles, userHelper} from "../mixins/UserMixin";
import CompanySelector from '../company/CompanySelector';
import LicenseReportTable from './LicenseReportTable';
import {printHelper} from "../mixins/PrintMixin";
import {Printd} from 'printd'
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";

export default {
    name: 'LicenseReport',
    components: {Navbar, CompanySelector, LicenseReportTable},
    mixins: [restApi, userHelper, printHelper],
    props: {
        isAdmin: {
            type: Boolean,
            default: false
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            users: [],
            company: null,
            superusers: [0, 0],
            observers: [0, 0],
            workers: [0, 0],
            months: [
                { value: 0, text: '01' },
                { value: 1, text: '02' },
                { value: 2, text: '03' },
                { value: 3, text: '04' },
                { value: 4, text: '05' },
                { value: 5, text: '06' },
                { value: 6, text: '07' },
                { value: 7, text: '08' },
                { value: 8, text: '09' },
                { value: 9, text: '10' },
                { value: 10, text: '11' },
                { value: 11, text: '12' }
            ],
            years: [],
            month: new Date().getMonth(),
            year: new Date().getFullYear(),
            loading: false
        }
    },
    computed: {
        userRoles() {
            const roles = JSON.parse(JSON.stringify(Roles));
            delete roles.ADMIN;
            delete roles.PRO_APP_USER;
            delete roles.MAP_VIEWER;
            return roles;
        }
    },
    mounted() {
        this.d = new Printd()
        const currentYear = new Date().getFullYear();
        const startYear = 2022;

        this.years = [];
        for (let year = startYear; year <= currentYear; year++) {
            this.years.push({
                value: year,
                text: year.toString()
            });
        }
    },
    methods: {
        print: function () {
            if (!this.loading) {
                this.d.print(document.getElementById('printContainer'), this.printStyle)
            }
        },
        initRoleSummary() {
            this.superusers = [0, 0]
            this.observers = [0, 0]
            this.workers = [0, 0]
            this.users.forEach(user => {
                if (user.superuser) {
                    this.superusers[0]++
                }
                if (user.observer) {
                    this.observers[0]++
                    if (user.worker) {
                        this.observers[1]++
                    }
                } else if (user.worker) {
                    this.workers[0]++
                }
            })
        },

        async fetchUsers() {
            this.users = []
            let date = new Date()
            date.setDate(1)
            date.setMonth(this.month)
            date.setFullYear(this.year)
            if(this.isAdmin && !this.company) {
                this.showAlert(this.$t('work_time.error_company_missing'))
                return;
            }
            this.loading = true;
            const { err, ...response } = await this.fetchLicenseReportUsers(date.toISOString(), this.company && this.company.id).catch((err) => ({err}));
            if (err) {
                this.showAlert(this.$t('common.error'))
                this.users = []
                this.loading = false;
                return;
            }
            this.users = response.data
            this.loading = false;
            this.initRoleSummary()
        },
    }
}
</script>
